<template lang="pug">
  y-dialog(v-model="showModal" fill-height fluid scrollable persistent transition="fade-transition" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card(flat)
      v-card-title.pa-4
        v-btn(text icon small @click="showModal = !showModal" height)
          eva-icon.mt-1(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
        div.ml-3.h6.primary500--text {{ $t('setup_local_order_settings') }}
      v-card-text.py-4.px-6
        v-window(v-model="step")

          v-window-item(:value="0")
            div.s1.basic600--text {{ $t('step_one_hours') }}
            div.s1.primary--text.mt-4 {{ $t('what_are_your_business') }}
            div.p2.basic700--text.mt-2 {{ $t('set_hours_when_orders') }}
            v-form.mt-4(ref="form1")
              business-hours(:parentHours.sync="hours" :hoursHeader="false")
          
          v-window-item(:value="1")
            div.s1.basic600--text {{ $t('step_two_scheduling') }}
            div.s1.primary--text.mt-4 {{ $t('can_your_customer_schedule') }}
            div.p2.basic700--text.mt-2 {{ $t('this_will_allow_customers') }}
            v-card.px-4.py-3.mt-6(flat :style="settings.scheduling_enabled ? `border:2px solid var(--v-info500); background-color: var(--v-infoT08)` : `border:1px solid var(--v-basic400);`" @click="settings.scheduling_enabled = true")
              div.text-uppercase {{ $t('yes') }}
            v-card.px-4.py-3.mt-2(flat :style="settings.scheduling_enabled === false ? `border:2px solid var(--v-info500); background-color: var(--v-infoT08)` : `border:1px solid var(--v-basic400);`" @click="settings.scheduling_enabled = false")
              div.text-uppercase {{ $t('no') }}

            template(v-if="settings.scheduling_enabled")
              div.s1.primary--text.mt-6 {{ $t('how_far_ahead') }}
              scheduling(:parentSettings.sync="settings")

          v-window-item(:value="2")
            div.s1.basic600--text {{ $t('step_three_preparation') }}
            div.s1.primary--text.mt-4 {{ $t('is_there_specified_amount') }}
            div.p2.basic700--text.mt-2 {{ settings.scheduling_enabled ? $t(this_reflected_earliest) : $t(this_reflected_expected) }}
            v-card.px-4.py-3.mt-6(flat :style="settings.preparation_time_enabled ? `border:2px solid var(--v-info500); background-color: var(--v-infoT08)` : `border:1px solid var(--v-basic400);`" @click="settings.preparation_time_enabled = true")
              div.text-uppercase {{ $t('yes') }}
            v-card.px-4.py-3.mt-2(flat :style="settings.preparation_time_enabled === false ? `border:2px solid var(--v-info500); background-color: var(--v-infoT08)` : `border:1px solid var(--v-basic400);`" @click="settings.preparation_time_enabled = false")
              div.text-uppercase {{ $t('no') }}

            v-form.mt-4(ref="form2")
              template(v-if="settings.preparation_time_enabled")
                div.s1.primary--text.mt-6 {{ $t('how_long_prepare') }}
                div.pa-4.mt-4(style="border:1px solid var(--v-basic400);")
                  div.label.basic600--text.text-uppercase {{ $t('preparation_time') }}
                  preparation-time.mt-2(:parentSettings.sync="settings")

          v-window-item(:value="3")
            div.s1.basic600--text {{ $t('step_four_cutoff') }}
            div.s1.primary--text.mt-4 {{ $t('do_have_last_order') }}
            div.p2.basic700--text.mt-2 {{ $t('this_is_last_time') }}
            v-card.px-4.py-3.mt-6(flat :style="settings.cut_off_time_enabled ? `border:2px solid var(--v-info500); background-color: var(--v-infoT08)` : `border:1px solid var(--v-basic400);`" @click="settings.cut_off_time_enabled = true")
              div.text-uppercase {{ $t('yes') }}
            v-card.px-4.py-3.mt-2(flat :style="settings.cut_off_time_enabled === false ? `border:2px solid var(--v-info500); background-color: var(--v-infoT08)` : `border:1px solid var(--v-basic400);`" @click="settings.cut_off_time_enabled = false")
              div.text-uppercase {{ $t('no') }}

            template(v-if="settings.cut_off_time_enabled")
              div.s1.primary--text.mt-6 {{ $t('when_is_cutoff') }}
              div.pa-4.mt-4(style="border:1px solid var(--v-basic400);")
                cut-off-time.mt-2(:parentSettings.sync="settings")

          v-window-item(:value="4")
            div.s1.basic600--text {{ $t('step_five_restricted') }}
            div.s1.primary--text.mt-4 {{ $t('please_specify_dates') }}
            div.p2.basic700--text.mt-2 {{ $t('these_dates_blocked') }}
            div.p2.basic700--text.mt-3 {{ $t('you_may_skip') }}
            
            v-form.mt-4(ref="form3")
              restricted-dates.mt-4(:parentSettings.sync="settings" :restrictedDatesHeader="false")

          v-window-item(:value="5")
            div.s1.basic600--text {{ $t('final_step_define') }}
            div.s1.primary--text.mt-4 {{ $t('please_select_manual_delivery') }}
            div.p2.basic700--text.mt-2 {{ $t('local_delivery_on_demand') }}
            
            local-delivery-rates.mt-4(:zones="zones" :manualRates="manualRates" :company="company")

            div.mb-2.d-flex
              eva-icon.mr-2(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" height="16" width="16")
              div.c1.basic600--text {{ $t('you_can_review_fulfilment') }}
          
          v-window-item(:value="6")
            v-row(no-gutters align="center" style="height: 400px;")
              v-col
                div.h5.basic700--text.text-center {{ $t('great_all_set') }}
                div.p1.primary--text.text-center.mt-4 {{ $t('review_selection_on_next') }}
                div.p1.primary--text.text-center {{ $t('start_accepting') }}
                div.p1.primary--text.text-center {{ $t('local_order_settings') }}

      v-card-actions
        v-spacer
        v-btn(v-if="step === 0" color="transparent" text @click="showModal = !showModal")
          .button-Aa-medium.primary400--text {{ $t('cancel') }}
        v-btn(v-else color="transparent" text @click="step--")
          .button-Aa-medium.primary400--text {{ $t('back') }}
        v-btn.ml-2(v-if="step === 6" @click="finishStep()" color="info500" dark depressed height="40" :loading="isLoading")
          .button-AA-medium.basic100--text {{ $t('finish') }}
        v-btn.ml-2(v-else color="info500" dark @click="nextStep()" depressed height="40")
          .button-AA-medium.basic100--text {{ $t('next') }}

</template>

<script>
import { mapActions } from 'vuex'
import BusinessHours from '@/components/ordersettings/BusinessHours.vue'
import Scheduling from '@/components/ordersettings/Scheduling.vue'
import PreparationTime from '@/components/ordersettings/PreparationTime.vue'
import CutOffTime from '@/components/ordersettings/CutOffTime.vue'
import RestrictedDates from '@/components/ordersettings/RestrictedDates.vue'
import LocalDeliveryRates from '@/components/ordersettings/LocalDeliveryRates.vue'

export default {
  name: 'LocalOrderSettingsSetup',
  components: { BusinessHours, Scheduling, PreparationTime, CutOffTime, RestrictedDates, LocalDeliveryRates },
  props: ['open', 'company'],
  data: () => ({
    step: 0,
    isLoading: false,
    originalHours: null,
    hours: {
      use_same_hours: true,
    },
    settings: {
      restricted_dates: [],
      enabled: true,
      scheduling_enabled: false,
      scheduling_begin_time_value: 0,
      scheduling_begin_time_unit: 'days',
      preparation_time_enabled: false,
      preparation_time_value: 30,
      preparation_time_unit: 'minutes',
      cut_off_time_enabled: false,
      cut_off_time: 30,
    },
    zones: [],
    manualRates: []
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.fetchBusinessHours()
    this.fetchZones()
    this.fetchManualRates()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchZones () {
      this.$axios.get(`/shipping/settings/${this.company.slug}/zones?page_size=-1`)
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.zones = resp.data.results
          }
        })
    },
    fetchManualRates () {
      this.$axios.get(`/shipping/settings/${this.company.slug}/manual_shippings?page_size=-1&pickup=false&ordering=id`)
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.manualRates = resp.data.results
          }
        })
    },
    fetchBusinessHours() {
      let defaultData = [
        { type_name: 'delivery', days: this.defaultBusinessHourDays() },
        { type_name: 'pickup', days: this.defaultBusinessHourDays() }
      ]
      this.hours = { ...this.constructObject([ ...defaultData ]) }
    },
    constructObject(data) {
      const object = {}

      const pickup =  data.filter(f => f.type_name == 'pickup')[0] || { type_name: 'pickup', days: [] }
      object.pickup_hours = this.processHours(pickup.days)

      const delivery = data.filter(f => f.type_name == 'delivery')[0] || { type_name: 'delivery', days: [] }
      object.delivery_hours = this.processHours(delivery.days)

      object.use_same_hours = JSON.stringify(object.pickup_hours) === JSON.stringify(object.delivery_hours)

      return object
    },
    processHours (days) {
      const hours = []
      if (days.length === 0) {
        const data = {
          data: { hours: [{ begin: null, begin_time: null, end: null, end_time: null }], order_limit_enabled: false, order_limit: null},
          days: []
        }
        hours.push(data)
        return hours
      }
      days.forEach(day => {
        const item = { ...day }
        delete item.day
        item.hours.forEach((h, index) => {
          item.hours[index].begin_time = this.formatTime(h.begin)
          item.hours[index].end_time = this.formatTime(h.end)
        })
        const id = JSON.stringify(item)
        const matchedItem = hours.filter(f => JSON.stringify(f.data) === id)[0]
        if (hours.length > 0 && matchedItem) {
          const index = hours.indexOf(matchedItem)
          hours[index].days.push(day.day)
        } else {
          const days = []
          days.push(day.day)
          const data = {
            data: item,
            days: days
          }
          hours.push(data)
        }
      })
      return hours
    },
    formatTime (time24) {
      let ts = time24
      const H = + ts.substr(0, 2)
      let h = (H % 12) || 12
      h = (h < 10) ? ('0' + h) : h
      const ampm = H < 12 ? 'am' : 'pm'
      ts = h + ':' + ts.substr(3, 2) + ampm
      return ts
    },
    getHourList(hours) {
      const list = []
      hours.forEach(hour => {
        hour.days.forEach(item => {
          const data = {
            ...hour.data,
            day: item
          }
          list.push(data)
        })
      })
      return list
    },
    defaultBusinessHourDays () {
      return [
        { day: 'Monday', order_limit_enabled: false, order_limit: null, hours: [{ begin: '08:00', end: '17:00' }] },
        { day: 'Tuesday', order_limit_enabled: false, order_limit: null, hours: [{ begin: '08:00', end: '17:00' }] },
        { day: 'Wednesday', order_limit_enabled: false, order_limit: null, hours: [{ begin: '08:00', end: '17:00' }] },
        { day: 'Thursday', order_limit_enabled: false, order_limit: null, hours: [{ begin: '08:00', end: '17:00' }] },
        { day: 'Friday', order_limit_enabled: false, order_limit: null, hours: [{ begin: '08:00', end: '17:00' }] }
      ]
    },
    nextStep  () {
      if (this.step === 0) {
        if (!this.$refs.form1.validate()) {
          return
        }
      }
      if (this.step === 2) {
        if (!this.$refs.form2.validate()) {
          return
        }
      }
      if (this.step === 4) {
        if (!this.$refs.form3.validate()) {
          return
        }
      }
      this.step++
    },
    finishStep () {
      this.isLoading = true
      let params = {
        ...this.settings,
        company_slug: this.company.slug,
        restricted_dates: this.settings.restricted_dates.map(m => { return m.date })
      }
      this.$axios.post(`/oms/`, params)
        .then(() => {
          this.saveBusinessHour()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    async saveBusinessHour () {
      let success = true
      const delivery = { 
        type_name: 'delivery',
        days: this.getHourList(this.hours.delivery_hours)
      }
      success = await this.saveData(delivery)
      if (this.hours.use_same_hours) {
        delivery.type_name = 'pickup'
        success = await this.saveData(delivery)
      } else {
        const pickup = { 
          type_name: 'pickup',
          days: this.getHourList(this.hours.pickup_hours)
        }
        success = await this.saveData(pickup)
      }
      if (success) {
        this.$emit('save')
        this.showModal = false
      } else {
        this.isLoading = false
      }
    },
    async saveData (param) {
      try {
        await this.axios.post(`/oms/${this.company.slug}/business_hours/`, param)
      } catch {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return false
      }
      return true
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "setup_local_order_settings": "Setup local order settings",
    "step_one_hours": "STEP 1: HOURS",
    "what_are_your_business": "What are your business hours?",
    "set_hours_when_orders": "Set hours when orders for pickup and local delivery will be fulfilled. You can even limit the number of orders you receive per day.",
    "step_two_scheduling": "STEP 2: SCHEDULING",
    "can_your_customer_schedule": "Can your customers schedule when they want to pickup or receive their order?",
    "this_will_allow_customers": "This will allow your customers to place an order even when you are closed. Date and time available for scheduling will depend on your set business hours.",
    "how_far_ahead": "How far ahead can they schedule their order?",
    "step_three_preparation": "STEP 3: PREPARATION TIME",
    "is_there_specified_amount": "Is there a specified amount of time that you need to prepare orders?",
    "this_reflected_earliest": "This will be reflected as the next earliest time your customers can select when scheduling for pickup or delivery.",
    "this_reflected_expected": "This will be reflected as an expected time that your customers will see at checkout.",
    "how_long_prepare": "How long does it take you to prepare orders?",
    "preparation_time": "preparation time",
    "step_four_cutoff": "STEP 4: CUT-OFF TIME",
    "do_have_last_order": "Do you have a last order time?",
    "this_is_last_time": "This is the last time an order will be processed for that business day. After this time, we will let the customer know that their order will be processed on the next business day.",
    "when_is_cutoff": "When is your cut-off time?",
    "step_five_restricted": "STEP 5: RESTRICTED DATES",
    "please_specify_dates": "Please specify any dates that you will not fulfill orders for local delivery and pickup.",
    "these_dates_blocked": "These dates will be blocked for local delivery and pickup. (i.e. public holidays, restock)",
    "you_may_skip": "You may skip this step and fill in these dates later.",
    "final_step_define": "FINAL STEP: DEFINE MANUAL RATES",
    "please_select_manual_delivery": "Please select which of your manual delivery rates are local delivery*",
    "local_delivery_on_demand": "*Local delivery: On-demand delivery type (e.g. Lalamove, Grab Express, own rider)",
    "you_can_review_fulfilment": "You can review the fulfilment type of your manual rates later when you manage your zones.",
    "great_all_set": "Great, you’re all set!",
    "review_selection_on_next": "Review your selections on the next",
    "start_accepting": "screen and you can start accepting",
    "local_order_settings": "orders with local order settings.",
    "cancel": "Cancel",
    "back": "Back",
    "finish": "Finish",
    "next": "Next"
  },
  "id": {
    "setup_local_order_settings": "Setup pengaturan pesanan lokal",
    "step_one_hours": "Langkah 1: Waktu",
    "what_are_your_business": "Tentukan jam kerja bisnis kamu?",
    "set_hours_when_orders": "Set hours when orders for pickup and local delivery will be fulfilled. You can even limit the number of orders you receive per day.",
    "step_two_scheduling": "Langkah 2: Penjadwalan",
    "can_your_customer_schedule": "Dapatkah pelanggan kamu menjadwalkan kapan mereka ingin mengambil atau menerima pesanan mereka?",
    "this_will_allow_customers": "Ini akan memungkinkan pelanggan kamu untuk memesan bahkan ketika kamu tutup. Tanggal dan waktu yang tersedia untuk penjadwalan akan bergantung pada jam kerja yang kamu tetapkan.",
    "how_far_ahead": "Seberapa lama pelanggan dapat menjadwalkan pesanan mereka?",
    "step_three_preparation": "Langkah 3: Waktu Persiapan",
    "is_there_specified_amount": "Apakah ada waktu tertentu yang kamu perlukan untuk menyiapkan pesanan?",
    "this_reflected_earliest": "This will be reflected as the next earliest time your customers can select when scheduling for pickup or delivery.",
    "this_reflected_expected": "Ini akan tercermin sebagai perkiraan waktu yang akan dilihat pelanggan kamu saat pembayaran.",
    "how_long_prepare": "Berapa lama waktu yang kamu butuhkan untuk menyiapkan pesanan?",
    "preparation_time": "Waktu Persiapan",
    "step_four_cutoff": "Langkah 4: Batasan Waktu",
    "do_have_last_order": "Apakah kamu memiliki waktu pemesanan terakhir?",
    "this_is_last_time": "Ini adalah terakhir kalinya pesanan akan diproses untuk hari kerja itu. Setelah waktu tersebut, kami akan memberi tahu pelanggan bahwa pesanan mereka akan diproses pada hari kerja berikutnya.",
    "when_is_cutoff": "Kapan batas waktu kamu?",
    "step_five_restricted": "Langkah 5: Batasan Tanggal",
    "please_specify_dates": "Harap tentukan tanggal kapan kamu tidak akan memenuhi pesanan untuk pengiriman dan pengambilan lokal.",
    "these_dates_blocked": "Tanggal-tanggal ini akan tiadakan untuk pengiriman dan pengambilan lokal. (yaitu hari libur nasional, restock)",
    "you_may_skip": "Anda dapat melewati langkah ini dan mengisi tanggal ini nanti.",
    "final_step_define": "Langkah Terakhir: Tentukan Tarif Manual",
    "please_select_manual_delivery": "Silakan pilih yang mana dari tarif pengiriman manual kamu yang merupakan pengiriman lokal*",
    "local_delivery_on_demand": "*Pengiriman lokal: Jenis pengiriman on-demand (e.g. Lalamove, Grab Express, own rider)",
    "you_can_review_fulfilment": "Anda dapat meninjau jenis pemenuhan tarif manual kamu nanti saat mengelola wilayah kamu.",
    "great_all_set": "Bagus, kamu sudah siap!",
    "review_selection_on_next": "Tinjau pilihan kamu di layar berikutnya",
    "start_accepting": "dan kamu dapat mulai menerima pesanan",
    "local_order_settings": "dengan pengaturan pesanan lokal",
    "cancel": "Batal",
    "back": "Kembali",
    "finish": "Selesai",
    "next": "Lanjut"
  },
  "ms": {
    "setup_local_order_settings": "Setup pengaturan pesanan lokal",
    "step_one_hours": "Langkah 1: Waktu",
    "what_are_your_business": "Tentukan jam kerja bisnis kamu?",
    "set_hours_when_orders": "Set hours when orders for pickup and local delivery will be fulfilled. You can even limit the number of orders you receive per day.",
    "step_two_scheduling": "Langkah 2: Penjadwalan",
    "can_your_customer_schedule": "Dapatkah pelanggan kamu menjadwalkan kapan mereka ingin mengambil atau menerima pesanan mereka?",
    "this_will_allow_customers": "Ini akan memungkinkan pelanggan kamu untuk memesan bahkan ketika kamu tutup. Tanggal dan waktu yang tersedia untuk penjadwalan akan bergantung pada jam kerja yang kamu tetapkan.",
    "how_far_ahead": "Seberapa lama pelanggan dapat menjadwalkan pesanan mereka?",
    "step_three_preparation": "Langkah 3: Waktu Persiapan",
    "is_there_specified_amount": "Apakah ada waktu tertentu yang kamu perlukan untuk menyiapkan pesanan?",
    "this_reflected_earliest": "This will be reflected as the next earliest time your customers can select when scheduling for pickup or delivery.",
    "this_reflected_expected": "Ini akan tercermin sebagai perkiraan waktu yang akan dilihat pelanggan kamu saat pembayaran.",
    "how_long_prepare": "Berapa lama waktu yang kamu butuhkan untuk menyiapkan pesanan?",
    "preparation_time": "Waktu Persiapan",
    "step_four_cutoff": "Langkah 4: Batasan Waktu",
    "do_have_last_order": "Apakah kamu memiliki waktu pemesanan terakhir?",
    "this_is_last_time": "Ini adalah terakhir kalinya pesanan akan diproses untuk hari kerja itu. Setelah waktu tersebut, kami akan memberi tahu pelanggan bahwa pesanan mereka akan diproses pada hari kerja berikutnya.",
    "when_is_cutoff": "Kapan batas waktu kamu?",
    "step_five_restricted": "Langkah 5: Batasan Tanggal",
    "please_specify_dates": "Harap tentukan tanggal kapan kamu tidak akan memenuhi pesanan untuk pengiriman dan pengambilan lokal.",
    "these_dates_blocked": "Tanggal-tanggal ini akan tiadakan untuk pengiriman dan pengambilan lokal. (yaitu hari libur nasional, restock)",
    "you_may_skip": "Anda dapat melewati langkah ini dan mengisi tanggal ini nanti.",
    "final_step_define": "Langkah Terakhir: Tentukan Tarif Manual",
    "please_select_manual_delivery": "Silakan pilih yang mana dari tarif pengiriman manual kamu yang merupakan pengiriman lokal*",
    "local_delivery_on_demand": "*Pengiriman lokal: Jenis pengiriman on-demand.",
    "you_can_review_fulfilment": "Anda dapat meninjau jenis pemenuhan tarif manual kamu nanti saat mengelola wilayah kamu.",
    "great_all_set": "Bagus, kamu sudah siap!",
    "review_selection_on_next": "Tinjau pilihan kamu di layar berikutnya",
    "start_accepting": "dan kamu dapat mulai menerima pesanan",
    "local_order_settings": "dengan pengaturan pesanan lokal",
    "cancel": "Batal",
    "back": "Kembali",
    "finish": "Selesai",
    "next": "Lanjut"
  }
}
</i18n>